import {displayTimeZone} from './display-timezone.js';
export function customerTimestamp(value,locale='da-DK') {
 const time=Date.parse(value??'');
 if(!Number.isFinite(time)||time<=31536000000)return undefined;
 return new Intl.DateTimeFormat(locale,{timeZone:displayTimeZone(),day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'}).format(time);
}
export function customerDataAge(value,locale='da-DK',now=Date.now()) {
 const time=Date.parse(value??'');if(!Number.isFinite(time)||time<=31536000000||time>now)return undefined;
 const minutes=Math.floor((now-time)/60000),unit=minutes<60?'minute':minutes<1440?'hour':'day',amount=unit==='minute'?minutes:unit==='hour'?Math.floor(minutes/60):Math.floor(minutes/1440);
 // Hermes does not supply RelativeTimeFormat on every native runtime. A
 // cosmetic age label must never prevent the tracker overview from opening.
 const RelativeTimeFormat=globalThis.Intl?.RelativeTimeFormat;
 if(typeof RelativeTimeFormat==='function') {
  try{return new RelativeTimeFormat(locale,{numeric:'auto'}).format(-amount,unit);}catch{/* Use the same supported languages without Intl. */}
 }
 const da=locale==='da-DK';
 if(amount===0)return da?'nu':'now';
 if(unit==='day'&&amount===1)return da?'i går':'yesterday';
 const labels=da?{minute:['minut','minutter'],hour:['time','timer'],day:['dag','dage']}:{minute:['minute','minutes'],hour:['hour','hours'],day:['day','days']};
 const label=labels[unit][amount===1?0:1];
 return da?`for ${amount} ${label} siden`:`${amount} ${label} ago`;
}
